import { useApolloClient } from '@apollo/client';
import { isObject } from 'lodash';
import { useCallback } from 'react';
import { type WebsiteModuleSpecsFragment } from '../../../../api/fragments';
import { type UploadFileWithPreviewFormDataFragment } from '../../../../api/fragments/UploadFileWithPreviewFormData';
import {
    type DeleteWebsiteSocialMediaAssetMutation,
    type DeleteWebsiteSocialMediaAssetMutationVariables,
    DeleteWebsiteSocialMediaAssetDocument,
} from '../../../../api/mutations/deleteWebsiteSocialMediaAsset';
import {
    type UploadWebsiteSocialMediaAssetMutation,
    type UploadWebsiteSocialMediaAssetMutationVariables,
    UploadWebsiteSocialMediaAssetDocument,
} from '../../../../api/mutations/uploadWebsiteSocialMediaAsset';

const useHandleWebsiteSocialMediaAsset = () => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (
            socialMediaId: string,
            values: UploadFileWithPreviewFormDataFragment | File,
            initialValues?: WebsiteModuleSpecsFragment
        ) => {
            const media = initialValues?.socialMedia.find(list => list.id === socialMediaId);

            if (values instanceof File) {
                await apolloClient.mutate<
                    UploadWebsiteSocialMediaAssetMutation,
                    UploadWebsiteSocialMediaAssetMutationVariables
                >({
                    mutation: UploadWebsiteSocialMediaAssetDocument,
                    variables: { socialMediaId, upload: values },
                });
            } else if (values === null || isObject(media?.icon)) {
                await apolloClient.mutate<
                    DeleteWebsiteSocialMediaAssetMutation,
                    DeleteWebsiteSocialMediaAssetMutationVariables
                >({
                    mutation: DeleteWebsiteSocialMediaAssetDocument,
                    variables: { socialMediaId },
                });
            }
        },
        [apolloClient]
    );
};

export default useHandleWebsiteSocialMediaAsset;
